import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from './authContext'
import Loading from './components/Loading'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
    const { session, userProfile, loading } = useAuth()

    if (loading) return <Loading isLoading={true} />
    if (!session) return <Navigate to="/login" replace />
    if (!userProfile) return <Loading isLoading={true} />
    if (!userProfile.company_id) return <Navigate to="/onboarding" replace />

    return <>{children}</>
}

export default ProtectedRoute
